module.exports = __webpack_public_path__ + "images/emoji/taxi.c8fef666a6b6ee626a40.png";